import React from "react";
import "./simple.css";

const Circular = () => {
  return <div className="spinner"></div>;
};

export default React.memo(Circular);
